export default "__VITE_ASSET__aysMHLwA__"